import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// Assuming UserInfoDTO is not an exported member of 'types/ApiTypes'
// and needs to be defined here or imported from a different module
// export interface UserInfoDTO {
//   id?: string | null
//   name?: string | null
//   email?: string | null
//   role?: string | null
// }
interface UserInfoDTO {
  Token: string | undefined
  Expiration: string | undefined
  id?: string | null
  name?: string | null
  email?: string | null
  role?: string | null
  Permissions: any
}
export interface IUserInfoSlice {
  user: UserInfoDTO | null
}
const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '') : null
const initialState: IUserInfoSlice = {
  user,
}

export const UserInfoSlice = createSlice({
  name: 'UserInfo',
  initialState,
  reducers: {
    setUserInfo: (state, action: PayloadAction<UserInfoDTO | null>) => {
      state.user = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { setUserInfo } = UserInfoSlice.actions

export default UserInfoSlice.reducer
